// extracted by mini-css-extract-plugin
export default {"pwaShadow":"styles_pwaShadow__N1Hp3"};